// Minimal Object.groupBy polyfill for environments without native support (e.g., Safari < 17.4)

if (typeof Object.groupBy !== 'function') {
  Object.groupBy = function groupBy(iterable, classifier) {
    if (iterable == null) {
      throw new TypeError('Object.groupBy: iterable is null or undefined')
    }
    if (typeof classifier !== 'function') {
      throw new TypeError('Object.groupBy: classifier must be a function')
    }
    const items = Array.isArray(iterable) ? iterable : Array.from(iterable)
    return items.reduce((acc, item, index) => {
      const key = classifier(item, index)
      const prop = typeof key === 'symbol' ? key : String(key)
      if (!Object.prototype.hasOwnProperty.call(acc, prop)) {
        acc[prop] = []
      }
      acc[prop].push(item)
      return acc
    }, Object.create(null))
  }
}
